import React, { Component } from "react";
import Navbar from "../../components/Navbar.js";
import {
  alert,
  format_date,
  GET,
  POST,
  PUT,
  DatePicker,
  toFixed,
  loading,
  project
} from "../../components/CustomComponent.js";
import Pagination from "@mui/material/Pagination";
import { stripJuristic } from "../../components/text-sanitize.js";
import { saveAs } from "file-saver";
import * as XLSX from "xlsx";
import "../../assets/css/bootstrap.css";
import "../../assets/css/style.css";
export default class UploadData extends Component {
  constructor(props) {
    super(props);
    this.state = {
      search: "",
      count: 0,
      date: "",
      visible: false,

      data: null,
      tab: 1,
      page1: 1,
      page2: 1,
      page3: 1,

      other_income: null,
      setting_id: "",
    };
    this.tableRef1 = React.createRef();
    this.tableRef2 = React.createRef();
    this.tableRef3 = React.createRef();
  }

  async componentDidMount() {
    this.GetSetting();
    loading(false);
    window.addEventListener("scroll", this.handleScroll);
  }

  componentWillUnmount() {
    window.removeEventListener("scroll", this.handleScroll);
  }

  handleScroll = () => {
    const { visible } = this.state;
    if (window.pageYOffset > 300 && !visible) {
      this.setState({ visible: true });
    } else if (window.pageYOffset <= 300 && visible) {
      this.setState({ visible: false });
    }
  };
  scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };
  GetSetting = async () => {
    let result = await GET("api/admin/setting-cash-flow-report/setting-list");
    if (result?.status) {
      this.setState({
        other_income: result.data.other_income,
        setting_id: result.data.setting_id,
      });
    }
  };
  UpdateSetting = async () => {
    const { other_income } = this.state;
    let id = this.state.setting_id;
    let body = { other_income };
    let result = await PUT(
      "api/admin/setting-cash-flow-report/setting-update/" + id,
      body
    );
  };
  CreateUpdate = async () => {
    loading(true);
    let body = this.state.data;
    let result = await POST("api/admin/upload-data", body);
    if (result?.status) {
      await this.UpdateSetting();
      // await GET("api/admin/user/create-customer", null);
      alert("#", "success");
    }
    loading(false);
  };
  handleFile = (file) => {
    loading(true);
    if (file) {
      const reader = new FileReader();
      reader.onload = (event) => {
        const fileContent = event.target.result;
        let text = fileContent
          .replaceAll("%5F%", "_")
          .replaceAll("%5D%", "]")
          .replaceAll("%5B%", "[")
          .replaceAll("%3A%", ":")
          .replaceAll("%7D%", "}")
          .replaceAll("%7B%", "{")
          .replaceAll("%22%", '"')
          .replaceAll("%2C%", ",");
        let data = JSON.parse(text);
        if(project?.project_code !== data.data_project?.project_code){
          loading(false);
          alert("","warning","แจ้งเตือน","ไฟล์ที่อัพโหลดไม่ตรงกับข้อมูลของโครงการ กรุณาลองใหม่อีกครั้ง");
          return
        }
        this.setState({
          data,
          other_income: {
            data: data.data_setting.setting_document_pay.map((e) => ({
              title: [
                {
                  type: "text",
                  value: e.title,
                  required: false,
                },
              ],
              amount: 0,
              visible: true,
              title_editable: false,
              amount_editable: true,
            })),
            show: false,
          },
        });
        loading(false);
      };
      reader.onerror = (error) => {
        loading(false);
        console.error("Error reading file:", error);
      };
      reader.readAsText(file);
    } else {
      loading(false);
      console.log("No file selected");
    }
  };

  ExportCSV = async (type, array) => {
    loading(true);
    // EXPORT CSV
    let json_data = [];
    if (type === "water") {
      json_data = array.map((item, index) => ({
        ลำดับ: index + 1,
        บ้านเลขที่: item.address_number || "",
        "ชื่อ - สกุล": item.full_name || "",
        วันที่ออกบิล: format_date(item.datetime_create) || "",
        เลขมาตร: item.current_gauge_number || "",
        จำนวนหน่วยที่ใช้: item.unit_used || 0,
        ค่าน้ำประปา: toFixed(item.water_bill) || "0.00",
        ค่ารักษาอุปกรณ์: toFixed(item.equipment_maintenance_fee) || "0.00",
        ค่าส่วนกลาง: toFixed(item.common_expenses) || "0.00",
        ค่าขยะ: toFixed(item.waste_cost) || "0.00",
        ค่าเคเบิล: toFixed(item.cable_cost) || "0.00",
        ค่าเบี้ยประกัน: toFixed(item.fire_cost) || "0.00",
        ค่าปรับล่าช้า: toFixed(item.total_cost_late) || "0.00",
        ค่าใช้จ่ายอื่นๆ: toFixed(item.other_income) || "0.00",
        "เพิ่ม/ลดหนี้": toFixed(item.add_debt - item.reduce_debt) || "0.00",
        รวม: toFixed(item.total_amount) || "0.00",
      }));
    } else if (type === "receipt") {
      json_data = array.map((item, index) => ({
        ลำดับ: index + 1,
        เลขที่ใบเสร็จ: item.iw_number || "",
        บ้านเลขที่: item.address_number || "-",
        "ชื่อ - สกุล": item.full_name_bill || "-",
        วันที่ออกบิล: format_date(item.record_date) || "-",
        จำนวนหน่วยที่ใช้: item.sum_unit_used || 0,
        ค่าน้ำประปา: item.s_water_bill ? toFixed(item.water_bill) : "0.00",
        ค่ารักษาอุปกรณ์: item.s_equipment_maintenance_fee
          ? toFixed(item.equipment_maintenance_fee)
          : "0.00",
        ค่าส่วนกลาง: item.s_common_expenses
          ? toFixed(item.common_expenses)
          : "0.00",
        ค่าขยะ: item.s_waste_cost ? toFixed(item.waste_cost) : "0.00",
        ค่าเคเบิล: item.s_cable_cost ? toFixed(item.cable_cost) : "0.00",
        ค่าเบี้ยประกัน: item.s_fire_cost ? toFixed(item.fire_cost) : "0.00",
        ค่าต่อกลับมิเตอร์: item.s_meter_connect_cost
          ? toFixed(item.meter_connect_cost)
          : "0.00",
        ค่าปรับล่าช้า: item.s_late_payment
          ? toFixed(item.late_payment)
          : "0.00",
        ค่าใช้จ่ายอื่นๆ: item.s_other_income
          ? toFixed(item.other_income)
          : "0.00",
        "เพิ่ม/ลดหนี้": toFixed(
          (item.s_add_debt ? item.add_debt : 0) +
            item.add_on_add_debt -
            ((item.s_reduce_debt ? item.reduce_debt : 0) +
              item.add_on_reduce_debt)
        ),
        ปรับปรุงยอดเงิน: toFixed(item.change_satang),
        รวม:
          toFixed(
            item.total_amount +
              item.add_on_add_debt -
              item.add_on_reduce_debt +
              item.change_satang
          ) || "0.00",
      }));
    } else if (type === "customer") {
      json_data = array.map((item, index) => ({
        ลำดับ: index + 1,
        "ชื่อ - นามสกุล": item.full_name || "",
        บ้านเลขที่: item.address_number || "",
        อาคาร: item.building || "",
        ชั้น: item.floor || "",
        เบอร์โทรศัพท์: item.mobile_phone || "",
      }));
    }
    // 1. Convert JSON to worksheet

    // 2. Create a new workbook and append the worksheet
    const workbook = XLSX.utils.book_new();
    const worksheet = XLSX.utils.json_to_sheet(json_data);
    XLSX.utils.book_append_sheet(workbook, worksheet, type);

    // 3. Write the workbook to binary buffer
    const excelBuffer = XLSX.write(workbook, {
      bookType: "xlsx",
      type: "array",
    });

    // 4. Save to file
    const data = new Blob([excelBuffer], { type: "application/octet-stream" });
    saveAs(data, `${type}.xlsx`);
    loading(false);
  };

  render() {
    const { data, tab, search, date, visible, page1, page2, page3 } =
      this.state;
    return (
      <div className="w-100 min-vh-100">
        <Navbar
          header="Transaction History"
          page1="หน้าหลัก"
          page2="อัพโหลดไฟล์ข้อมูล"
        />
        <div className="body px-3 pb-3 pt-0">
          {!data ? (
            <div className="w-100">
              <h4 className="fw-bold mb-2">อัพโหลดไฟล์ข้อมูล</h4>
              <input
                hidden
                id="file"
                type="file"
                onChange={async (e) => {
                  loading(true);
                  const file = e.target.files[0];
                  this.handleFile(file);
                }}
              />
              <div
                className="select-image w-100 py-5 d-flex align-items-center justify-content-center border-secondary bg-contain border-2 border-dash rounded-3 pointer"
                onClick={() => document.getElementById("file").click()}
                onDragOver={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                }}
                onDrop={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  const file = e.dataTransfer.files?.[0];
                  this.handleFile(file);
                }}
              >
                <div className="text-center text-secondary py-5">
                  <span className="icon text-48">{"\uf15b"}</span>
                  <h5>อัพโหลดไฟล์ข้อมูล</h5>
                  <label>
                    รองรับรูปแบบไฟล์ TXT และขนาดไฟล์ไม่เกิน 50 เมกะไบท์
                  </label>
                </div>
              </div>
            </div>
          ) : (
            <div>
              <div>
                <h4 className="fw-bold mb-2">อัพโหลดไฟล์ข้อมูล</h4>
                <hr />
                <h4 className="fw-bold">ข้อมูลโครงการ</h4>
                <div className="row">
                  <div className="col-6 col-sm-4 col-md-2 mx-auto mb-3">
                    <img
                      alt="logo"
                      src={data?.data_project?.picture}
                      className="w-100"
                    />
                  </div>
                  <div className="col-12 col-md-10">
                    <div className="row">
                      <div className="col-12 col-sm-6 d-flex mb-2">
                        <div className="fw-bold wpx-100">ชื่อโครงการ</div>
                        <span>{stripJuristic(data?.data_project?.project_name)}</span>
                      </div>
                      <div className="col-12 col-sm-6 d-flex mb-2">
                        <div className="fw-bold wpx-100">เบอร์โทรศัพท์</div>
                        <span>{data?.data_project?.phone_number}</span>
                      </div>
                      <div className="col-12 col-sm-6 d-flex mb-2">
                        <div className="fw-bold wpx-100">เลขที่ผู้เสียภาษี</div>
                        <span>{data?.data_project?.tax_number}</span>
                      </div>
                      <div className="col-12 col-sm-6 d-flex mb-2">
                        <div className="fw-bold wpx-100">ที่อยู่</div>
                        <span>
                          {data?.data_project?.address_detail} ตำบล{" "}
                          {data?.data_project?.address_obj?.SUB_DISTRICT} อำเภอ{" "}
                          {data?.data_project?.address_obj?.DISTRICT} จังหวัด{" "}
                          {data?.data_project?.address_obj?.PROVINCE}{" "}
                          {data?.data_project?.address_obj?.ZIPCODE}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <hr />
              <div className="d-flex justify-content-between flex-wrap">
                <h4 className="fw-bold mb-3">
                  {tab === 1
                    ? "ข้อมูลน้ำ"
                    : tab === 2
                    ? "ข้อมูลบิล"
                    : tab === 3
                    ? "ข้อมูลลูกบ้าน"
                    : ""}
                </h4>
                <div
                  className="border rounded-3 border-success mb-2 me-2"
                  style={{ padding: 1, height: 38 }}
                >
                  <button
                    className={
                      tab === 1
                        ? "btn btn-success wpx-110 mb-0"
                        : "btn btn-outline-success border-0 wpx-110 mb-0"
                    }
                    onClick={() => this.setState({ tab: 1 })}
                  >
                    ข้อมูลน้ำ
                  </button>
                  <button
                    className={
                      tab === 2
                        ? "btn btn-success wpx-110 mb-0"
                        : "btn btn-outline-success border-0 wpx-110 mb-0"
                    }
                    onClick={() => this.setState({ tab: 2 })}
                  >
                    ข้อมูลบิล
                  </button>
                  <button
                    className={
                      tab === 3
                        ? "btn btn-success wpx-110 mb-0"
                        : "btn btn-outline-success border-0 wpx-110 mb-0"
                    }
                    onClick={() => this.setState({ tab: 3 })}
                  >
                    ข้อมูลลูกบ้าน
                  </button>
                </div>
              </div>

              <div className="d-flex flex-wrap">
                <input
                  type="text"
                  className="form-control wpx-200 me-2 mb-2"
                  placeholder="ค้นหา..."
                  onChange={(e) => {
                    this.setState({ search: e.target.value });
                  }}
                  value={search}
                />
                {tab !== 3 && (
                  <div className="wpx-200 me-2 mb-2">
                    <DatePicker
                      className="form-control"
                      onChange={(e) => {
                        this.setState({ date: e });
                      }}
                      value={date}
                    />
                  </div>
                )}
                {tab === 1 && (
                  <button
                    className="btn btn-warning px-3 mb-2"
                    onClick={() => {
                      this.ExportCSV("water", data.data_water);
                    }}
                  >
                    Excel
                  </button>
                )}
                {tab === 2 && (
                  <button
                    className="btn btn-warning px-3 mb-2"
                    onClick={() => {
                      this.ExportCSV("receipt", data.data_receipt);
                    }}
                  >
                    Excel
                  </button>
                )}
                {tab === 3 && (
                  <button
                    className="btn btn-warning px-3 mb-2"
                    onClick={() => {
                      this.ExportCSV("customer", data.data_customer);
                    }}
                  >
                    Excel
                  </button>
                )}
              </div>
              <div className="mb-5">
                {tab === 1 && (
                  <div className="card rounded border-0 overflow-hidden">
                    <div className="p-2">
                      จำนวนทั้งสิ้น {data?.data_water?.length || 0} รายการ
                    </div>
                    <div className="table-responsive">
                      <table className="table table-hover mb-0">
                        <thead className="bg-light text-secondary">
                          <tr>
                            <th className="wpx-50 text-center">ลำดับ</th>
                            <th className="text-nowrap">บ้านเลขที่</th>
                            <th className="text-nowrap">ชื่อ - สกุล</th>
                            <th className="text-nowrap">วันที่ออกบิล</th>
                            <th className="text-nowrap">เลขมาตร</th>
                            <th className="text-nowrap">จำนวนหน่วยที่ใช้</th>
                            <th className="text-nowrap">ค่าน้ำประปา</th>
                            <th className="text-nowrap">ค่ารักษาอุปกรณ์</th>
                            <th className="text-nowrap">ค่าส่วนกลาง</th>
                            <th className="text-nowrap">ค่าขยะ</th>
                            <th className="text-nowrap">ค่าเคเบิล</th>
                            <th className="text-nowrap">ค่าเบี้ยประกัน</th>
                            <th className="text-nowrap">ค่าปรับล่าช้า</th>
                            <th className="text-nowrap">ค่าใช้จ่ายอื่นๆ</th>
                            <th className="text-nowrap">เพิ่ม/ลดหนี้</th>
                            <th className="text-nowrap">รวม</th>
                          </tr>
                        </thead>
                        <tbody>
                          {data?.data_water
                            ?.filter(
                              (item) =>
                                !search ||
                                (item.address_number + item.full_name).includes(
                                  search
                                )
                            )
                            .slice((page1 - 1) * 100, page1 * 100)
                            .map((item, index) => (
                              <tr key={"table_" + index}>
                                <td>{index + 1}</td>
                                <td>{item.address_number || ""}</td>
                                <td>{item.full_name || ""}</td>
                                <td>
                                  {format_date(item.datetime_create) || ""}
                                </td>
                                <td>{item.current_gauge_number || ""}</td>
                                <td>{item.unit_used || 0}</td>
                                <td>{toFixed(item.water_bill) || "0.00"}</td>
                                <td>
                                  {toFixed(item.equipment_maintenance_fee) ||
                                    "0.00"}
                                </td>
                                <td>
                                  {toFixed(item.common_expenses) || "0.00"}
                                </td>
                                <td>{toFixed(item.waste_cost) || "0.00"}</td>
                                <td>{toFixed(item.cable_cost) || "0.00"}</td>
                                <td>{toFixed(item.fire_cost) || "0.00"}</td>
                                <td>
                                  {toFixed(item.total_cost_late) || "0.00"}
                                </td>
                                <td>{toFixed(item.other_income) || "0.00"}</td>
                                <td>
                                  {toFixed(item.add_debt - item.reduce_debt) ||
                                    "0.00"}
                                </td>
                                <td>{toFixed(item.total_amount) || "0.00"}</td>
                              </tr>
                            ))}
                        </tbody>
                      </table>
                      <div className="w-100 d-flex align-items-center justify-content-between p-3">
                        <small>ทั้งหมด {data?.data_water.length} รายการ</small>
                        <Pagination
                          count={Math.ceil(data?.data_water.length / 100)}
                          showFirstButton
                          showLastButton
                          onChange={(_, page) => {
                            this.setState({ page1: page });
                          }}
                        />
                      </div>
                    </div>
                  </div>
                )}
                {tab === 2 && (
                  <div className="card rounded border-0 overflow-hidden">
                    <div className="p-2">
                      จำนวนทั้งสิ้น {data?.data_receipt?.length || 0} รายการ
                    </div>
                    <div className="table-responsive">
                      <table
                        className="table table-hover mb-0"
                        ref={this.tableRef2}
                      >
                        <thead className="bg-light text-secondary">
                          <tr>
                            <th className="wpx-50 text-center">ลำดับ</th>
                            <th>เลขที่ใบเสร็จ</th>
                            <th>บ้านเลขที่</th>
                            <th>ชื่อ - สกุล</th>
                            <th>วันที่ออกบิล</th>
                            <th>จำนวนหน่วยที่ใช้</th>
                            <th>ค่าน้ำประปา</th>
                            <th>ค่ารักษาอุปกรณ์</th>
                            <th>ค่าส่วนกลาง</th>
                            <th>ค่าขยะ</th>
                            <th>ค่าเคเบิล</th>
                            <th>ค่าเบี้ยประกัน</th>
                            <th>ค่าต่อกลับมิเตอร์</th>
                            <th>ค่าปรับล่าช้า</th>
                            <th>ค่าใช้จ่ายอื่นๆ</th>
                            <th>เพิ่ม/ลดหนี้</th>
                            <th>ปรับปรุงยอดเงิน</th>
                            <th>รวม</th>
                          </tr>
                        </thead>
                        <tbody>
                          {data?.data_receipt
                            ?.filter(
                              (item) =>
                                !search ||
                                (
                                  item.address_number +
                                  item.full_name_bill +
                                  item.iw_number
                                ).includes(search)
                            )
                            .slice((page2 - 1) * 100, page2 * 100)
                            .map((item, index) => (
                              <tr key={"table_" + index}>
                                <td>{index + 1}</td>
                                <td>{item.iw_number || ""}</td>
                                <td>{item.address_number || "-"}</td>
                                <td>{item.full_name_bill || "-"}</td>
                                <td>{format_date(item.record_date) || "-"}</td>
                                <td>{item.sum_unit_used || 0}</td>
                                <td>
                                  {item.s_water_bill
                                    ? toFixed(item.water_bill)
                                    : "0.00"}
                                </td>
                                <td>
                                  {item.s_equipment_maintenance_fee
                                    ? toFixed(item.equipment_maintenance_fee)
                                    : "0.00"}
                                </td>
                                <td>
                                  {item.s_common_expenses
                                    ? toFixed(item.common_expenses)
                                    : "0.00"}
                                </td>
                                <td>
                                  {item.s_waste_cost
                                    ? toFixed(item.waste_cost)
                                    : "0.00"}
                                </td>
                                <td>
                                  {item.s_cable_cost
                                    ? toFixed(item.cable_cost)
                                    : "0.00"}
                                </td>
                                <td>
                                  {item.s_fire_cost
                                    ? toFixed(item.fire_cost)
                                    : "0.00"}
                                </td>
                                <td>
                                  {item.s_meter_connect_cost
                                    ? toFixed(item.meter_connect_cost)
                                    : "0.00"}
                                </td>
                                <td>
                                  {item.s_late_payment
                                    ? toFixed(item.late_payment)
                                    : "0.00"}
                                </td>
                                <td>
                                  {item.s_other_income
                                    ? toFixed(item.other_income)
                                    : "0.00"}
                                </td>
                                <td>
                                  {toFixed(
                                    (item.s_add_debt ? item.add_debt : 0) +
                                      item.add_on_add_debt -
                                      ((item.s_reduce_debt
                                        ? item.reduce_debt
                                        : 0) +
                                        item.add_on_reduce_debt)
                                  )}
                                </td>
                                <td>{toFixed(item.change_satang)}</td>
                                <td>
                                  {toFixed(
                                    item.total_amount +
                                      item.add_on_add_debt -
                                      item.add_on_reduce_debt +
                                      item.change_satang
                                  ) || "0.00"}
                                </td>
                              </tr>
                            ))}
                        </tbody>
                      </table>

                      <div className="w-100 d-flex align-items-center justify-content-between p-3">
                        <small>
                          ทั้งหมด {data?.data_receipt.length} รายการ
                        </small>
                        <Pagination
                          count={Math.ceil(data?.data_receipt.length / 100)}
                          showFirstButton
                          showLastButton
                          onChange={(_, page) => {
                            this.setState({ page2: page });
                          }}
                        />
                      </div>
                    </div>
                  </div>
                )}
                {tab === 3 && (
                  <div className="card rounded border-0 overflow-hidden">
                    <div className="p-2">
                      จำนวนทั้งสิ้น {data?.data_customer?.length || 0} รายการ
                    </div>
                    <div className="table-responsive">
                      <table
                        className="table table-hover mb-0"
                        ref={this.tableRef3}
                      >
                        <thead className="bg-light text-secondary">
                          <tr>
                            <th className="wpx-50 text-center">ลำดับ</th>
                            <th>ชื่อ - นามสกุล</th>
                            <th>บ้านเลขที่</th>
                            <th>อาคาร</th>
                            <th>ชั้น</th>
                            <th>เบอร์โทรศัพท์</th>
                          </tr>
                        </thead>
                        <tbody>
                          {data?.data_customer
                            ?.filter(
                              (item) =>
                                !search ||
                                (item.address_number + item.full_name).includes(
                                  search
                                )
                            )
                            .slice((page3 - 1) * 100, page3 * 100)
                            .map((item, index) => (
                              <tr key={"table_" + index}>
                                <td>{index + 1}</td>
                                <td>{item.full_name || ""}</td>
                                <td>{item.address_number || ""}</td>
                                <td>{item.building || ""}</td>
                                <td>{item.floor || ""}</td>
                                <td>{item.mobile_phone || ""}</td>
                              </tr>
                            ))}
                        </tbody>
                      </table>
                      <div className="w-100 d-flex align-items-center justify-content-between p-3">
                        <small>
                          ทั้งหมด {data?.data_customer.length} รายการ
                        </small>
                        <Pagination
                          count={Math.ceil(data?.data_customer.length / 100)}
                          showFirstButton
                          showLastButton
                          onChange={(_, page) => {
                            this.setState({ page3: page });
                          }}
                        />
                      </div>
                    </div>
                  </div>
                )}
              </div>
              <div
                className="w-100 d-flex justify-content-end mt-2 position-fixed bg-white p-2"
                style={{ bottom: 0, left: 0 }}
              >
                <button
                  className="btn btn-danger px-5 me-1"
                  onClick={() => {
                    window.location.reload();
                  }}
                >
                  ล้างข้อมูล
                </button>
                <button
                  className="btn btn-success px-5 ms-1"
                  onClick={() => {
                    this.CreateUpdate();
                  }}
                >
                  บันทึก
                </button>
              </div>
            </div>
          )}
          {visible && (
            <button
              className="position-fixed btn btn-primary"
              onClick={() => {
                this.scrollToTop();
              }}
              style={{ top: 30, right: 30 }}
            >
              กดเพื่อไปยังด้านบน
            </button>
          )}
        </div>
      </div>
    );
  }
}
